<app-form-user
    [dataItem]="dataItem"
    [userListDelegate]="userListDelegateUse"
    [groupListBase]="groupListBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-user>

